import React from 'react'
import gql from 'graphql-tag'
import _ from 'lodash'

import apolloClient from '../../../services/ApolloClient'
import GraphqlQuery from '../../molecules/GraphqlQuery'
import ResearchTimePeriodSelector from './ResearchTimePeriodSelector'

const STATE = gql`
  query ResearchTimePeriodSelectorContainerState {
    research @client {
      selectedTheme {
        id
        name
      }
      selectedPeriod {
        start
        end
      }
      landTenureRange {
        start
        end
        items
      }
    }
  }
`

const QUERY = gql`
  query ResearchTimePeriodSelectorContainerQuery($themeId: Int!) {
    yearRangeByTheme(id: $themeId) {
      range: ano_range
      rangeStart: ano_min
      rangeEnd: ano_max
    }
  }
`

export default class ResearchTimePeriodSelectorContainer extends React.PureComponent {
  handleStartChange(start) {
    apolloClient.writeData({
      data: {
        research: {
          __typename: 'ResearchState',
          selectedPeriod: {
            __typename: 'ResearchSelectedPeriodState',
            start
          }
        }
      }
    })
  }

  handleEndChange(end) {
    apolloClient.writeData({
      data: {
        research: {
          __typename: 'ResearchState',
          selectedPeriod: {
            __typename: 'ResearchSelectedPeriodState',
            end
          }
        }
      }
    })
  }

  generateRange(rangeObject) {
    if (rangeObject) {
      return [rangeObject.rangeStart, rangeObject.rangeEnd]
    }

    return undefined
  }

  generateMarks(range) {
    return _.reduce(range, (object, year, index) => {
      object[index] = `${year}`
      return object
    }, {})
  }

  redefaultSelectedPeriod(start, end) {
    if(start !== undefined && end !== undefined) {
      apolloClient.writeData({
        data: {
          research: {
            __typename: 'ResearchState',
            selectedPeriod: {
              __typename: 'ResearchSelectedPeriodState',
              start,
              end
            }
          }
        }
      });
    }
  }

  renderComponent = ({ research }) => (
    <GraphqlQuery
      query={ QUERY }
      variables={{ themeId: research.selectedTheme.id }}
    >
      {({ yearRangeByTheme: range }) => {
        let currentStart = research.selectedPeriod.start
        let currentEnd = research.selectedPeriod.end

        if(range == undefined) {
          range = {
            range: 2001,
            rangeStart: 2000,
            rangeEnd: 2023
          };
        }

        if(research.selectedTheme.name == 'FUNDIARIO') {
          range = {
            range: research.landTenureRange.items,
            rangeStart: research.landTenureRange.start,
            rangeEnd: research.landTenureRange.end
          };
        }
        
        if (!_.includes(range.range, currentStart) || !_.includes(range.range, currentEnd)) {
          this.redefaultSelectedPeriod(_.first(range.range), _.last(range.range))
        }

        return (
          <ResearchTimePeriodSelector
            marks={ this.generateMarks(range.range) }
            range={ [range.rangeStart, range.rangeEnd] }
            start={ research.selectedPeriod.start }
            end={ research.selectedPeriod.end }
            onStartChange={ this.handleStartChange }
            onEndChange={ this.handleEndChange }
          />
        )
      }}
    </GraphqlQuery>
  )

  render() {
    return (
      <GraphqlQuery query={ STATE }>
        { this.renderComponent }
      </GraphqlQuery>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/ResearchTimePeriodSelector/ResearchTimePeriodSelector.container.js